import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { prepareExcelData } from "./excelUtils";

/**
 * Export PDF using same data structure as Excel
 */
export const exportToPDF = (list, columns, fileName = "Report.pdf", title = "Report") => {
  if (!list || list.length === 0) return;

  // Reuse your existing formatter
  const data = prepareExcelData(list, columns);

  const doc = new jsPDF("landscape"); // use portrait if fewer columns

  // Title
  doc.setFontSize(14);
  doc.text(title, 14, 15);

  // Prepare table headers
  const tableColumn = columns.map(col => col.header);

  // Prepare table rows
  const tableRows = data.map(row =>
    tableColumn.map(header => row[header])
  );

  // Generate table
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 20,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      textColor: [0, 0, 0]   // 👈 pure black
    },
    headStyles: {
      fillColor: [79, 129, 189], // blue header
      textColor: 255,
      fontStyle: "bold"
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    },
    margin: { top: 20 }
  });

  doc.save(fileName);
};
